import { jwtDecode } from 'jwt-decode';

export const url = {
    home: () => '/',

    catalog: () => '/shop/catalog',

    category: (product) => `/shop/catalog/${product.parent?.slug}`,

    product: (product) => `/shop/products/${product.id || product._id}`,
};

export function getCategoryParents(category) {
    return category.parent ? [...getCategoryParents(category.parent), category.parent] : [];
}

export const formatDate = (dateString) => {
    if (!dateString) return '';

    return new Date(dateString).toLocaleDateString('fr-FR', {
        year: 'numeric',
        day: '2-digit',
        month: 'long',
    });
};

export const isRefreshTokenExpired = (token) => {
    console.log(token, "token");

    if (token == undefined) {
        return false
    }
    try {
        const decoded = jwtDecode(token);
        return decoded.exp * 1000 < Date.now(); // Comparer l'expiration avec le timestamp actuel
    } catch (error) {
        console.error("Erreur lors de la vérification du token :", error);
        return true; // Si erreur, on considère expiré
    }
};